module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image22.37cba23c.webp";